/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { MaintenanceErrorContent } from 'fetcher';
import React from 'react';
import { Heading } from './Heading';
import { Icon, maintenanceIcon } from './Icon';
import { Text } from './Text';
import { Wrapper } from './Wrapper';
import { COLOR } from './styles';

const MAX_WIDTH = '576px';

const Term = styled.div`
  max-width: ${MAX_WIDTH};
  background-color: #fff;
  padding: 16px;
  font-size: 16px;
  line-height: 1.7;
  border-radius: 4px;
  color: ${COLOR.font.base};
  border: 1px solid ${COLOR.border.base};
`;

const Hr = styled.hr`
  max-width: ${MAX_WIDTH};
  border-top: 1px dashed ${COLOR.border.base};
`;

type Props = MaintenanceErrorContent;

export const Maintenance: React.FC<Props> = ({
  title,
  japanese,
  english,
  japaneseTerm,
  englishTerm,
}) => (
  <Wrapper data-cy-page-type="maintenance" data-cy-page-id>
    <Icon icon={maintenanceIcon} css={{ margin: '0 auto' }} />
    <Heading css={{ marginTop: '32px' }}>{title}</Heading>
    <Text
      css={{ marginTop: '16px' }}
      dangerouslySetInnerHTML={{ __html: japanese }}
    />
    {japaneseTerm && (
      <Term
        css={{ margin: '16px auto 0' }}
        dangerouslySetInnerHTML={{ __html: japaneseTerm }}
      />
    )}
    <Hr css={{ margin: '16px auto 0' }} />
    <Text
      css={{ marginTop: '16px' }}
      dangerouslySetInnerHTML={{ __html: english }}
    />
    {englishTerm && (
      <Term
        css={{ margin: '16px auto 0' }}
        dangerouslySetInnerHTML={{ __html: englishTerm }}
      />
    )}
  </Wrapper>
);
